import { Model } from "@bryntum/schedulerpro";

export class ClientIntegrationsModel extends Model {
  static get $name() {
    return "ClientIntegrationsModel";
  }

  declare key: string;
  declare value: string;
  declare clientId: number;

  static get fields() {
    return ["key", "value", { name: "clientId", dataSource: "client", type: "number" }];
  }
}

// @ts-expect-error exposeProperties is an internal method
ClientIntegrationsModel.exposeProperties();
